import { Action } from '../../actions';
import { SAVE_IMPORT_EXPORT_WIZARD } from '../../actions/importExportWizard/saveImportExportWizard';
import { SAVE_IMPORT_EXPORT_WIZARD_SUCCESS } from '../../actions/importExportWizard/saveImportExportWizardSuccess';
import { UPDATE_IMPORT_EXPORT_WIZARD_LOCK } from '../../actions/importExportWizard/updateImportExportWizardLock';
import { UPDATE_IMPORT_EXPORT_WIZARD_MODE } from '../../actions/importExportWizard/updateImportExportWizardMode';
import { UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY } from '../../actions/importExportWizard/updateImportExportWizardVisibility';
import {
    ImportExportWizardMode,
    ImportExportWizardState,
    ImportExportWizardStatus
} from '../../typings/importExportWizard';

import { saveImportExportWizard } from './saveImportExportWizard';
import { saveImportExportWizardSuccess } from './saveImportExportWizardSuccess';
import { updateImportExportWizardLock } from './updateImportExportWizardLock';
import { updateImportExportWizardMode } from './updateImportExportWizardMode';
import { updateImportExportWizardVisibility } from './updateImportExportWizardVisibility';

export const getImportExportWizardInitialState = (): ImportExportWizardState => ({
    cid: '62182930',
    isVisible: false,
    isLocked: true,
    status: ImportExportWizardStatus.SAVED,
    wizardMode: ImportExportWizardMode.IMPORT
});

export function importExportWizard(
    state: ImportExportWizardState = getImportExportWizardInitialState(),
    action: Action
): ImportExportWizardState {
    switch (action.type) {
        case UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY:
            return updateImportExportWizardVisibility(state, action);

        case UPDATE_IMPORT_EXPORT_WIZARD_MODE:
            return updateImportExportWizardMode(state, action);

        case UPDATE_IMPORT_EXPORT_WIZARD_LOCK:
            return updateImportExportWizardLock(state, action);

        case SAVE_IMPORT_EXPORT_WIZARD:
            return saveImportExportWizard(state, action);

        case SAVE_IMPORT_EXPORT_WIZARD_SUCCESS:
            return saveImportExportWizardSuccess(state, action);

        default:
            return state;
    }
}
